// リストを取得
const listElems = Array.from(document.getElementsByClassName('remove-last-margin-list'));
let marginBottomNum = [];

const getMarginBottom = (ulElem) => {
    let liElems = Array.from(ulElem.children);
    marginBottomNum.push(getComputedStyle(liElems[0]).getPropertyValue("margin-bottom"));
}
const marginBottom = () => {
    listElems.forEach(listElem => {
        getMarginBottom(listElem);
    });

}
window.addEventListener('load', marginBottom);

// 入: HTML要素
// 出: Y座標数値
const getYPosition = (elem) => {
    let clientRect = elem.getBoundingClientRect() ;
    return window.pageYOffset + clientRect.top;
}

const removeLastLineMargin = (ulElem) => {
    let liElems = Array.from(ulElem.children);
    let liElemsYPotitions = liElems.map(getYPosition);
    let uniqueliElemsYPotitions = Array.from(new Set(liElemsYPotitions));
    let lastRowYposition = uniqueliElemsYPotitions[uniqueliElemsYPotitions.length - 1 ];

    let lastRowLiElems = liElems.filter((elem) => {
        return getYPosition(elem) == lastRowYposition;
    })

    for (let i = 0; i < liElems.length; i++) {
        liElems[i].style.marginBottom = "";
    }

    for (let index = 0; index < lastRowLiElems.length; index++) {
        lastRowLiElems[index].style.marginBottom = 0 + 'px';
    }

}

const removeMargins = () => {

    listElems.forEach(listElem => {
        removeLastLineMargin(listElem);
    });

}
window.addEventListener('load', removeMargins);
window.addEventListener('resize', removeMargins);